<div class="section-padding-vertical-md lg:section-padding-vertical-lg w-full">
    <div class="w-full rounded-large bg-secondary-600 flex flex-col md:flex-row relative">
        <div class="col-span-3 flex flex-col gap spacing-md md:spacing-lg">
            <h2 class="text-white z-10">
                Bist du bereit, deiner Konkurrenz endlich einen Schritt voraus zu sein?
            </h2>

            <wci-button
                routerLink="/kontakt"
                class="z-10 block"
                label="Jetzt Marktführer werden"
                variant="secondary"
                >Jetzt Marktführer werden</wci-button
            >
        </div>

        <div class="flex">
            <img alt="Alessandro Crispino - Geschäftsführer der WeCodeIt OG" loading="lazy"
                src="images/team/wecodeit_alessandro_cut.webp"
                class="origin-bottom-right md:rounded-br-[2.75rem] m-auto md:m-0 max-w-[12rem] scale-110" />
        </div>
    </div>
</div>
